import type { ImageLoaderProps } from 'next/image';
import { staticImageSources } from '../../static-image-config.mjs';

export default function staticImageLoader({ src, width, quality }: ImageLoaderProps): string {
  const name = staticImageSources[src as keyof typeof staticImageSources];
  if (!name) {
    throw new Error(`Local image is not registered for static export: ${src}`);
  }
  return `/assets/static-images/${name}/w${width}-q${quality ?? 85}.webp`;
}
